import React, { memo } from 'react'
import { Box, Card, useTheme } from '@mui/material'

import brandConfig from 'brandConfig'

const ProdegeFrame = ({ authId, token }) => {
  const { palette } = useTheme()
  const iframeUrl =
    `https://web.bitlabs.ai/?UID=${authId}&token=${token}` +
    // `&currency=Coins` +
    // `&custom_logo_url=https://yourdomain.com/logo.png` +
    // `&navigation_color=${palette.primary.main}` +
    // `&background_color=${palette.background.default}` +
    // `&interaction_color=${palette.primary.light}` +
    // `&survey_icon_color=${palette.success.main}` +
    `&theme=${palette.mode}`
  return (
    <Card>
      <Box
        sx={{
          width: '100%',
          height: 'calc(100vh - 235px)',
          border: 'none',
          overflow: 'hidden'
        }}
      >
        <iframe
          src={iframeUrl}
          title={brandConfig.name}
          width='100%'
          height='100%'
          style={{ border: 'none' }}
          allow='fullscreen'
        ></iframe>
      </Box>
    </Card>
  )
}

export default memo(ProdegeFrame)
